import { render, staticRenderFns } from "./VideoPromo.vue?vue&type=template&id=3832a27a&scoped=true"
import script from "./VideoPromo.vue?vue&type=script&lang=js"
export * from "./VideoPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832a27a",
  null
  
)

export default component.exports